import { TTreeOption } from '@/common/components/redesigned/TreeMultiselect/types';

/**
 * Рекурсивно ищет элемент в дереве по значению
 * @param tree - дерево опций
 * @param value - значение для поиска
 * @returns найденный элемент или null
 */
const findOptionByValue = (tree: TTreeOption[], value: number | string): TTreeOption | null => {
  for (const option of tree) {
    if (option.value === value) {
      return option;
    }

    if (option.options && option.options.length > 0) {
      const found = findOptionByValue(option.options, value);
      if (found) {
        return found;
      }
    }
  }

  return null;
};

/**
 * Находит названия элементов по их значениям в дереве
 * @param tree - дерево опций
 * @param values - массив значений для поиска
 * @returns массив названий элементов
 */
export const findTreeOptionLabels = (tree: TTreeOption[], values: (number | string)[]): string[] => {
  if (!tree || !values || values.length === 0) {
    return [];
  }

  const labels: string[] = [];

  for (const value of values) {
    const option = findOptionByValue(tree, value);
    if (option) {
      labels.push(option.label);
    }
  }

  return labels;
};

/**
 * Форматирует список элементов через запятую
 * @param tree - дерево опций
 * @param values - массив значений
 * @returns отформатированная строка с названиями элементов
 */
export const getBaseTreeInfo = (tree: TTreeOption[], values: (number | string)[]): string => {
  return findTreeOptionLabels(tree, values).join(', ');
};
